module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG97e79262cc1e0a2a7a63f7e7786c4b39.97e79262.png";